import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
export function getInboxChannelsTableUrl({
  inboxId
}) {
  return `${getFullUrl('app')}/live-messages-settings/${PortalIdParser.get()}/inboxes/${inboxId}/channels`;
}